/**
 * HomeSlider Module
 *
 * This module handles the homepage slider functionality
 */

import jQuery from 'jquery';
import 'jquery-ui/ui/widgets/slider';
import 'slick-carousel';

const HomeSlider = {
  homeSlider: function (homeController, isMobile) {
    let $homeCurrentStatus = jQuery('.home-slider-controller .current-slider'),
      $homeTotalStatus = jQuery('.home-slider-controller .total-slider'),
      $homeSliderControler,
      $homeSlider = jQuery('.home-slider'),
      $homeSliderContent = jQuery('.home-slider-content'),
      slider,
      homeTotalCount,
      slickCurrSlide;

    // Set initial numbers based on DOM count before any initialization
    const initialSlideCount = $homeSlider.children().length;
    $homeCurrentStatus.text('1');
    $homeTotalStatus.text(initialSlideCount);

    // Initialize the home-slider-content first
    $homeSliderContent.not('.slick-initialized').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.home-slider',
      dots: false,
      fade: true,
      arrows: false,
      cssEase: 'ease',
      focusOnSelect: true,
    });

    // Initialize jQuery UI Slider before main slider
    slider = jQuery('.home-slider-controller .progress-bar').slider({
      min: 0,
      max: 100,
      animate: 'slow',
      step: 0.001,
      value: 25, // Set initial value to 25%
      slide: function (event, ui) {
        const slick = $homeSlider.slick('getSlick');
        const count = slick.slideCount - 1;
        const calcPct = ui.value / 100;
        const goTo = Math.floor(count * calcPct);

        $homeSlider.slick('slickGoTo', goTo);
        $homeSliderContent.slick('slickGoTo', goTo);
      },
    });

    // Bind events before initialization
    $homeSlider.on('init', function (event, slick) {
      homeTotalCount = slick.slideCount;

      // Calculate and set initial segment width for progress bar handle
      const segmentWidth = (100 / slick.slideCount).toFixed(4);
      jQuery('.home-slider-controller .ui-slider-handle').css({
        width: segmentWidth + '%',
        'margin-left': '-' + segmentWidth + '%',
      });
    });

    // Initialize main slider with proper configuration
    $homeSlider.not('.slick-initialized').slick({
      arrows: false,
      prevArrow:
        '<div class="slick-arrow slider-prev"><svg><use xlink:href="#left-arrow"></use></svg></div>',
      nextArrow:
        '<div class="slick-arrow slider-next"><svg><use xlink:href="#right-arrow"></use></svg></div>',
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      cssEase: 'ease',
      autoplay: true,
      autoplaySpeed: 5000,
      asNavFor: '.home-slider-content',
    });

    // Setup afterChange handlers
    $homeSlider.on('afterChange', function (event, slick, currentSlide) {
      $homeCurrentStatus.text(currentSlide + 1);
      $homeTotalStatus.text(slick.slideCount);

      // Update progress bar position
      const newValue = ((currentSlide + 1) / slick.slideCount) * 100;
      slider.slider('value', newValue);
    });

    // Setup arrow click handlers to control both sliders
    jQuery('.home-slider-controller .left-arrow').on('click', function () {
      $homeSlider.slick('slickPrev');
      $homeSliderContent.slick('slickPrev');
    });

    jQuery('.home-slider-controller .right-arrow').on('click', function () {
      $homeSlider.slick('slickNext');
      $homeSliderContent.slick('slickNext');
    });
  },

  // Remove video captions
  removeVideoCaptions: function () {
    let vid = document.getElementById('home-membership-vid');
    if (vid && vid.textTracks && vid.textTracks[0]) {
      vid.textTracks[0].mode = 'hidden';
    }
  },

  init: function (homeController, isMobile) {
    this.homeSlider(homeController, isMobile);
    this.removeVideoCaptions();
  },
};

export default HomeSlider;
